import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SplashPage() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // 淡入动画
    const fadeIn = setTimeout(() => setVisible(true), 100);
    // 3秒后跳转到登录页
    const redirect = setTimeout(() => navigate('/login'), 3000);
    return () => {
      clearTimeout(fadeIn);
      clearTimeout(redirect);
    };
  }, [navigate]);

  return (
    <div
      className="h-full w-full flex flex-col items-center justify-center relative overflow-hidden"
      style={{ background: '#EDE8F5', fontFamily: "'Noto Sans SC', sans-serif" }}
    >
      {/* 背景弥散光晕 */}
      <div className="absolute inset-0 pointer-events-none">
        <div
          style={{
            position: 'absolute',
            top: '20%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 280,
            height: 280,
            borderRadius: '50%',
            background: 'rgba(181,198,224,0.18)',
            filter: 'blur(80px)',
          }}
        />
        <div
          style={{
            position: 'absolute',
            bottom: '25%',
            left: '20%',
            width: 160,
            height: 160,
            borderRadius: '50%',
            background: 'rgba(197,185,216,0.15)',
            filter: 'blur(60px)',
          }}
        />
      </div>

      {/* 内容区 */}
      <div
        className="flex flex-col items-center z-10 transition-all duration-1000"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(16px)',
          marginTop: '-80px',
        }}
      >
        {/* Logo */}
        <img
          src="https://public.readdy.ai/ai/img_res/57e672ec-ca18-4086-9dfa-c077778cd419.png"
          alt="轻醒 Logo"
          className="w-32 h-32 object-contain"
        />

        {/* App 名字 */}
        <h1
          className="mt-6 font-semibold"
          style={{
            fontSize: 36,
            color: '#8B9DC3',
            letterSpacing: 10,
            fontFamily: "'Noto Sans SC', sans-serif",
          }}
        >
          轻醒
        </h1>

        {/* 标语 */}
        <p
          className="mt-3 tracking-wider"
          style={{
            fontSize: 15,
            color: '#A8A8B8',
            letterSpacing: 4,
          }}
        >
          每天清醒一点点
        </p>
      </div>

      {/* 底部加载指示器 */}
      <div
        className="absolute bottom-16 left-1/2 -translate-x-1/2 flex gap-1.5 z-10 transition-opacity duration-1000"
        style={{ opacity: visible ? 1 : 0 }}
      >
        {[0, 1, 2].map(i => (
          <div
            key={i}
            className="rounded-full"
            style={{
              width: 6,
              height: 6,
              background: '#B5C6E0',
              animation: `splashBounce 1.2s ${i * 0.2}s infinite ease-in-out`,
            }}
          />
        ))}
      </div>

      {/* 动画关键帧 */}
      <style>{`
        @keyframes splashBounce {
          0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
          40% { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </div>
  );
}